import React, { useEffect, useState } from "react";
import { Formik, Form, FormikHelpers } from "formik";
import LoginForm from "./LoginForm";
import { object, string } from "yup";
import { useNavigate } from "react-router-dom";
import { showToast } from "src/utils/showToaster";

import { AppDispatch } from "src/redux/store";
import { useDispatch, useSelector } from "react-redux";
import { setAccessToken, setUserData } from "src/redux/slices/AuthSlice";
import { useLoginMutation } from "src/services/AuthServices";
import {
  authTokenKeyName,
  refreshTokenKeyName,
} from "src/utils/configs/authConfig";
import { RootState } from "src/redux/store";

export type LoginFormInitialValues = {
  email: string;
  password: string;
};

const LoginFormWrapper = () => {
  const [isInvalidPassword, setIsInvalidPassword] = useState<boolean>(false);
  const dispatch = useDispatch<AppDispatch>();

  const authToken = localStorage.getItem("authToken");
  const navigate = useNavigate();

  useEffect(() => {
    if (!authToken) {
      navigate("/");
    } else {
      navigate("/dashboard");
    }
  }, [authToken, navigate]);

  const afterLogin = (res: any) => {
    localStorage.setItem(authTokenKeyName, res?.data?.token);
    localStorage.setItem(refreshTokenKeyName, res?.data?.refreshToken);
    // localStorage.setItem("userType", res?.userType);
    // localStorage.setItem("deviceId", res?.deviceId);
    localStorage.setItem(
      "userData",
      JSON.stringify({
        name: res?.data?.name,
        mobile: res?.data?.mobile,
        email: res?.data?.email,
        userId: res?.data?.userId,
        userType: res?.data?.userType,
        roleId :res?.accessModules?._id
      })
    );
    dispatch(setAccessToken(res?.accessToken));
    dispatch(
      setUserData(
        {
          name: res?.data?.name,
          mobile: res?.data?.mobile,
          email: res?.data?.email,
          userId: res?.data?.userId,
          userType: res?.data?.userType,
          roleId :res?.accessModules?._id
        } || null
      )
    );
  };
  const [login] = useLoginMutation();
  const initialValues: LoginFormInitialValues = {
    email: "",
    password: "",
  };

  const validationSchema = object({
    email: string().email("Invalid email").required("Email is required"),
    password: string().required("Password is required"),
  });

  const handleSubmit = async (
    values: LoginFormInitialValues,
    { setSubmitting }: FormikHelpers<LoginFormInitialValues>
  ) => {
    setSubmitting(true);
    try {
      await login(values).then((res: any) => {
        setSubmitting(false);
        if (res?.error) {
          showToast("error", res?.error?.data?.message);
        } else {
          if (res?.data?.status) {
            showToast("success", res?.data?.message);
            afterLogin(res?.data);
            navigate("/dashboard");
          } else {
            showToast("error", res?.data?.message);
            setIsInvalidPassword(true);
          }
        }
      });
    } catch (error) {
      // Handle any other errors that occur
      setIsInvalidPassword(false);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setIsInvalidPassword(false);
    }, 1000);
  }, [isInvalidPassword]);

  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <LoginForm
              formikProps={formikProps}
              isInvalidPassword={isInvalidPassword}
            />
          </Form>
        )}
      </Formik>
    </>
  );
};

export default LoginFormWrapper;
